import { useEffect, useState } from "react";
import { getClubAll, postClub } from "../api/golfClubAPI";
import swal from 'sweetalert2';
import * as helper from '../global/helper';


const Cart = (props) =>{

    const [club,                  setClub]                  = useState({});

    useEffect(() => {
        props.title("Cart", "cart")
        fetchClub();
    }, []);

    const fetchClub = async() =>{
        try {
            const clubs = await getClubAll()   
            setClub(clubs);             
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })  
        }
    }
    const updateClubDetails = (field, value) => {   
        setClub((d) => {
            return { ...d, [field]: value };
        });
    };

    const addClubHandler = async() => {

        const btn = $('#btnSave');
        var form = $('#add-Cart-form');
        
        form.validate({
            rules: { 
                txtCartCount: {
                    required: true,
                    number: true
                },
                txtCaddyCount: {
                    required: true,
                    number: true
                }       
            },
            messages: { 
                txtCartCount: {
                    required: "This field is required"
                },
                txtCaddyCount: {
                    required: "This field is required"
                } 
            }
        });

        if (!form.valid()) return;
        helper.StartProcessing(btn);

        try {
            await postClub(club);
            helper.StopProcessing(btn);
            fetchClub();
            swal.fire({
                toast: true,
                icon: 'success',
                titleText: 'Cart updated successfully!',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 1500,
                animation: false,
                customClass: {
                    popup: 'margin-20',
                },
            });

        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    }



    return(
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet kt-portlet--mobile">
                        <div className="kt-portlet__body padding-t30 padding-b0">
                            <form className="kt-form" id="add-Cart-form">
                                <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Total Cart <span className="red">*</span></label>
                                        <div className="col-xl-4 col-lg-5">
                                            <input 
                                                id="txtCartCount" 
                                                name="txtCartCount" 
                                                type="number" 
                                                className="form-control"
                                                value={club.CartCount || ''}
                                                onChange={(event) => updateClubDetails('CartCount', event.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Total Caddy <span className="red">*</span></label>
                                        <div className="col-xl-4 col-lg-5">
                                            <input 
                                                id="txtCaddyCount" 
                                                name="txtCaddyCount" 
                                                type="number" 
                                                className="form-control"
                                                value={club.CaddyCount || ''}
                                                onChange={(event) => updateClubDetails('CaddyCount', event.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <div className="row">
                                    <div className="col-lg-9 ml-lg-auto">
                                        <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={addClubHandler}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
 export default Cart;